module.exports = {
    cy: {
        // myroot contains things that aren't translated automatically.
        // You can just reference myroot.[whatever] and it'll translate.
        // It needs to be called myroot
        myroot: {
            Vero: 'Fero',
            modules: 'Modiwlau',
            modulesMenu: 'I gyd Modiwlau',
            module: 'Modiwl',
            researchModules: 'Modiwlau parth',
            researchModule: 'Modiwl parth',
            status: 'Statws',
            moduleCode: 'Cod y modiwl',
            courses: 'Cwrsiau',
            coursesMenu: 'I gyd Cwrsiau',
            associateCourses: 'Cyrsiau Cysylltiol',
            researchCourses: 'Cyrsiau Ymchwil',
            course: 'Cwrsiau',
            parentCourseCode: 'Cod cwrs i rieni',
            parentCourseTitle: 'Titwl cwrs i rieni',
            parentCourseQualification: 'Cymhwyster cwrs i rieni',
            courseInstances: 'Enghreifftiau o gwrs',
            staticData: 'Data statig',
            qualificationId: 'Cymhwyster',
            qualificationAims: 'Nodau Cymhwyso',
            criteria: 'Meini prawf',
            intermediateOrFinal: 'Canolradd neu derfynol',
            intermediate: 'Canolradd',
            final: 'Derfynol',
            CourseLevels: 'Lefelau cwrs',
            FacultyGroups: 'Ysgolion/cyfarwyddiaethau',
            FacultySubGroups: 'Meysydd pwnc',
            FacultyGroup: 'Ysgolion/cyfarwyddiaethau',
            FacultySubGroup: 'Meysydd pwnc',
            optional: 'Dewisol',
            core: 'Craidd',
            specified: 'Bennir',
            CreditLevel: 'Lefel credyd',
            CreditValue: 'Gwerth credyd',
            duration: 'Hyd',
            modeOfStudy: 'Dull astudio',
            modeOfDelivery: 'Dull cyflwyno',
            campusLocation: 'Lleoliad',
            deliveryInstitution: 'Sefydliad cyflenwi',
            assessments: 'Asesiadau',
            startDate: 'Dyddiad cychwyn',
            endDate: 'Dyddiad gorffen',
            yearOfStudy: 'Flwyddyn astudio',
            academicSession: 'Sesiwn academaidd',
            prerequisite: 'Hanfodol',
            corequisite: 'Cydanghenraid',
            requisiteType: 'Math gofynnol',
            ascCode: 'ASC Codau',
            jacsCode: "JACS Codau",
            immersiveLearning: 'Dysgu trochi',
            employability: 'Cyflogadwyedd',
            version: 'Fersiwn',
            moduleInformation: 'Gwybodaeth am y modiwl',
            moduleAdditionalInfo: 'Gwybodaeth Ychwanegol',
            learningAndTeaching: 'Dysgu Ac Addysgu',
            code: 'Cod',
            description: 'Disgrifiad',
            franchise: "Masnachfraint",
            graduateAttributes: 'Nodweddion Dedigion',
            assessmentType: "Math o asesiad",
            category: 'Categori asesu',
            durationInMin: 'Hyd (Mun)',
            wordCount: 'Cyfrif geiriau',
            weight: 'Pwysau',
            maximumMark: 'Marc Uchafswm',
            passMark: 'Marc pasio',
            isBestOfAssessment: "Yw'r gorau o",
            HECOScodes: 'HECoS Codau',
            validationFrom: 'Dilysu o',
            validationTo: 'Dilysu i',
            copyDelivery: 'Anfon copi',
            copy: 'Anfon',
            AwardingBody:'Corff Dyfarnu',
            CertificateTitle:'Teitl Tystysgrif',
            CertificateTitleWelsh:'Tystysgrif Teitl CYMRAEG',
            ModesOfStudy:'Dulliau Astudio'
        },
        resources: {
            Module: {
                name: 'Modiwl |||| Modiwlau',
                fields: {
                    shortTitle: 'Teitl Modiwl',
                    facultyId: 'Cyfadran',
                    departmentId: 'Adran',
                    validationFrom: 'Dilysu gan',
                    validationTo: 'Dilysu i',
                    subjectId: 'Pwnc',
                    readingList: 'Rhestr ddarllen',
                    statusId: 'Statws',
                    creditLevelId: 'Lefel credyd',
                    creditValueId: 'Gwerth credyd',
                    languageId: 'Iaith astudio',
                    providesEmployability: 'Cyflogadwyedd',
                    offersImmersiveLearning: 'Dysgu trochi',
                    moduleLeader: 'Arweinydd modiwl',
                    moduleTeam: 'Tîm modiwl',
                    moduleCode: 'Cod modiwl',
                    moduleAims: "Nodau'r modiwl",
                    contentSummary: "Crynodeb o'r cynnwys",
                    creditLevel: 'Lefel credyd',
                    creditValue: 'Gwerth credyd',
                    versioningType: 'Fersiwn math',
                    firstIntendedIntake: 'Y cymeriant cyntaf a fwriadwyd',
                    finalYearOfIntake: 'Blwyddyn olaf y derbyn',
                    requisiteType: 'Math gofynnol',
                    learningOutcomes: "Gwybodaeth a ' u dealltwriaeth",
                    closedDate: 'Dyddiad cau',
                    moduleLearningOutcomes: 'Canlyniadau dysgu modiwl',
                    assessmentCriteriaList: 'Meini prawf asesu',
                    HECOScodes: 'HECoS Codau',
                    jacsCodes: 'JACS Codau'
                }
            },            
            Course: {
                name: 'Cwrs |||| Cwrsiau',
                fields: {
                    Title: 'Teitl',                    
                    facultyId: 'Cyfadran',
                    departmentId: 'Ysgol/Gyfarwyddiaeth',
                    subjectId: 'Maes Pwnc',
                    courseCode: 'Cod y cwrs',
                    version: 'Fersiwn',
                    courseLevelId: 'Lefel cwrs',
                    statusId: 'Statws',
                    professionalBodyIds: 'Gyrff proffesiynol',
                    languageId: 'Iaith astudio',
                    instanceIds: 'Achosion',
                    moduleIds: 'Modiwlau craidd',
                    progressionRoutes: 'Llwybrau dilyniant',
                    progressionForOtherCourses: "Os yw'r wobr hon yn llwybr dilyniant ar gyfer cyrsiau eraill, nodwch y cwrs a ble mae'n cael ei gyflwyno.",
                    courseSpecificRegs: 'Mae Rheoliadau Cwrs-Benodol yn bodoli',
                    transitionalArrangements: 'Trefniadau trosiannol',
                    qaaBenchmarks: 'ASA Meincnodau',
                    validationFrom: 'Dilysu o',
                    validationTo: 'Dilysu i',
                    dateClosed: 'Dyddiad cau',
                    finalEnrolment: 'Blwyddyn olaf y derbyn',
                    hecosCodes: 'HECoS Codau',
                    entryRequirements: 'Gofynion mynediad',
                    courseExitPoints: 'Mannau ymadael',
                    exitPoints: 'Mannau ymadael',
                    partnerInstitutionAddendum: "Atodiad i ' w gyflwyno mewn sefydliad partner",
                    teachingMethods: 'Dulliau addysgu',
                    employerEngagement: 'Ymgysylltu â chyflogwyr',
                    meansOfAssessment: 'Dull o asesu',
                    learningSupport: 'Cymorth dysgu',
                    educationalAims: 'Nodau addysgol',
                    improvementMethods: 'Dulliau ar gyfer gwella ansawdd a safonau',
                    qualityIndicators: 'Dangosyddion ansawdd a safonau',
                    learningOutcomes: "Gwybodaeth a ' u dealltwriaeth",
                    intellectualLearningOutcomes: 'Sgiliau deallusol',
                    keySkillLearningOutcomes: 'Sgiliau allweddol',
                    graduateLearningOutcomes: 'Priodoleddau graddedig',
                    professionalLearningOutcomes: 'Sgiliau proffesiynol/galwedigaethol',
                    moduleInfos: 'Modiwlau',
                    versioningType: 'Fersiwn math',
                    requiresDBScheck: 'Angen gwiriad DBS',
                    GA1CommercialAwareness: 'ND1 Ymwybyddiaeth fasnachol',
                    GA2Communication: 'ND2 Cyfathrebu',
                    GA3Leadership: 'ND3 Arweinyddiaeth',
                    GA4InnovationEnterprise:'ND4 Arloesi a Menter',
                    GA5ProjectManagement: 'ND5 Rheoli prosiect',
                    GA6DigitalLiteracy: 'ND6 Llythrennedd Digidol',
                    additionalCosts: 'Costau ychwanegol',
                    ucasCode:'Ucas Cod',
                    numberOfIntakes:'Nifer y Derbyniadau',
                    additionalStudy:'Astudiaeth Ychwanegol',
                    approvedDate:'Dyddiad Cymeradwyo'
                }
            },
            CourseInstance: {
                name: "Enghraifft o gwrs |||| Enghreifftiau o'r cwrs",                
                fields: {
                    courseCode: 'Cod y cwrs',
                    locationDescription: 'Lleoliad'
                }
            },
            CreditLevel: {
                name: 'Lefel credyd |||| Lefelau credyd',
                fields: {
                    Title: 'Lefel credyd',
                    description: 'Disgrifiad'
                }
            },
            CourseLevel: {
                name: 'Lefel cwrs |||| Lefelau cwrs',
                fields: {
                    maxcredits: 'Uchafswm credydau',
                    description: 'Lefel cwrs'
                }
            },
            FacultyGroup: {
                name: 'Ysgol/Gyfarwyddiaeth |||| Ysgolion/cyfarwyddiaethau'
            },
            FacultySubGroup: {
                name: 'Maes Pwnc |||| Meysydd pwnc'
            },
            Assessment: {
                name: 'Asesiad |||| Asesiadau',
                fields: {
                    title: 'Cod asesu',
                    assessmentType: "Math o asesiad",
                    category: "Categori asesu"
                }
            }
        }
    },
    en: {
        // myroot contains things that aren't translated automatically.
        // You can just reference myroot.[whatever] and it'll translate.
        // It needs to be called myroot
        myroot: {
            Vero: 'Vero',
            modules: 'Modules',
            modulesMenu: 'Standard Modules',
            module: 'Module',
            researchModules: 'Research Modules',
            researchModule: 'Research Module',
            moduleCode: 'Module Code',
            status: 'Status',
            courses: 'Courses',
            coursesMenu: 'Courses',
            coursesMenuSearch: 'Search Courses',
            course: 'Course',
            associateCourses: 'Associate Courses',
            researchCourses: 'Research Courses',
            parentCourseCode: 'Parent Course Id',
            parentCourseTitle: 'Parent Course Title',
            parentCourseQualification: 'Parent Course Qualification',
            courseInstances: 'Course Instances',
            staticData: 'Static Data',
            qualificationId: 'Qualification',
            qualificationAims: 'Qualificaiton Aims',
            criteria: 'Criteria',
            intermediateOrFinal: 'Intermediate or Final',
            intermediate: 'Intermediate',
            final: 'Final',
            CourseLevels: 'Course Levels',
            FacultyGroup: 'School/Directorate',
            FacultySubGroup: 'Subject Area',
            FacultyGroups: 'Schools/Directorates',
            FacultySubGroups: 'Subject Areas',
            optional: 'Optional',
            core: 'Core',
            specified: 'Specified',
            CreditLevel: 'Credit Level',
            CreditValue: 'Credit Value',
            duration: 'Duration',
            modeOfStudy: 'Mode of Study',
            modeOfDelivery: 'Nature of Delivery',
            campusLocation: 'Campus Location',
            deliveryInstitution: 'Delivery institution',
            assessments: 'Assessments',
            startDate: 'Start Date',
            endDate: 'End Date',
            yearOfStudy: 'Year of Study',
            academicSession: 'Academic Session',
            prerequisite: 'Pre-Requisite',
            corequisite: 'Co-Requisite',
            requisiteType: 'Requisite Type',
            ascCode: 'ASC Codes',
            jacsCode: "JACS Codes",
            immersiveLearning: 'Immersive learning',
            employability: 'Employability',
            moduleInformation: 'Module Information',
            moduleAssessments: 'Assessments',
            moduleAdditionalInfo: 'Additional Information',
            learningAndTeaching: 'Learning And Teaching',
            version: 'Version',
            code: 'Code',
            description: 'Description',
            franchise: "Franchise",
            graduateAttributes: 'Graduate Attributes',
            assessmentType: "Assessment Type",
            category: "Assessment Category",
            durationInMin: 'Duration (Min)',
            wordCount: 'Word Count',
            weight: 'Weight',
            maximumMark: 'Maximum Mark',
            passMark: 'Pass Mark',
            isBestOfAssessment: 'Is best of',
            HECOScodes: 'HECoS Codes',
            validationFrom: 'Validated From',
            validationTo: 'Validated To',
            accredited: 'Accredited',
            selfaccredited: 'Self-accredited',
            recognised: 'Recognised',
            endorsed: 'Endorsed',
            partnership: 'Partnership',
            ga1commericalawareness: 'GA1 Commerical Awareness',
            ga2communication: 'GA2 Communication',
            ga3leadership: 'GA3 Leadership',
            ga4innovationandent: 'GA4 Innovation and Enterprise',
            ga5projectmanagement: 'GA5 Project Management',
            ga6digitalliteracy: 'GA6 Digital Literacy',
            copyDelivery: 'Copy delivery',
            copy: 'Copy',
            AwardingBody:'Awarding Body',
            CertificateTitle:'Certificate Title',
            CertificateTitleWelsh:'Certificate Title Welsh',
            ModesOfStudy:'Modes Of Study'
        },
        resources: {
            Module: {
                name: 'Module |||| Modules',
                fields: {
                    shortTitle: 'Module title',
                    languageId: 'Language of Study',
                    versioningType: 'Version type',
                    assessmentCriteriaList:'Assessment Criteria'
                }
            },
            Course: {
                name: 'Course |||| Courses',
                fields: {
                    Title: 'Title',
                    departmentId: 'School/Directorate',
                    subjectId: 'Subject Area',
                    professionalBodyIds: 'Professional Bodies',
                    languageId: 'Language of Study',
                    instanceIds: 'Instances',
                    moduleIds: 'Core Modules',
                    progressionRoutes: 'Progression Routes',
                    progressionForOtherCourses: 'If this award is a progression route for other courses, please specify the course and where it is delivered.',
                    courseSpecificRegs: 'Course-Specific Regulations exist',
                    transitionalArrangements: 'Transitional Arrangements',
                    qaaBenchmarks: 'QAA Benchmarks',
                    validationFrom: 'Validated From',
                    validationTo: 'Validated To',
                    approveDate: 'Approve Date',
                    dateClosed: 'Date Closed',                    
                    finalEnrolment: 'Final year of Intake',
                    hecosCodes: 'HECoS Codes',
                    partnerInstitutionAddendum: 'Addendum for delivery at a partner institution',
                    improvementMethods: 'Methods for improving the quality and standards',
                    qualityIndicators: 'Indicators of quality and standards',
                    learningOutcomes: 'Knowledge and Understanding',
                    intellectualLearningOutcomes: 'Intellectual Skills',
                    keySkillLearningOutcomes: 'Key Skills',
                    professionalLearningOutcomes: 'Professional/Vocational Skills',
                    graduateLearningOutcomes: 'Graduate Attributes',
                    moduleInfos: 'Modules',
                    versioningType: 'Version type',
                    requiresDBScheck: 'Requires DBS check',
                    GA1CommercialAwareness: 'GA1 Commercial Awareness',
                    GA2Communication: 'GA2 Communication',
                    GA3Leadership: 'GA3 Leadership',
                    GA4InnovationEnterprise: 'GA4 Innovation and Enterprise',
                    GA5ProjectManagement: 'GA5 Project Management',
                    GA6DigitalLiteracy: 'GA6 Digital Literacy',
                    additionalCosts: 'Additional Costs',
                    ucasCode:'Ucas Code',
                    numberOfIntakes:'Number Of Intakes',
                    additionalStudy:'Additional Study',
                    approvedDate:'Approved Date'
                }
            },
            AssociateCourse: {
                name: ' Associate Course ||||  Associate Courses',
                fields: {
                    Title: 'Title',
                    departmentId: 'School/Directorate',
                    subjectId: 'Subject Area',
                    professionalBodyIds: 'Professional Bodies',
                    instanceIds: 'Instances',
                    moduleIds: 'Core Modules'
                }
            },
            CourseInstance: {
                name: "Course Instance |||| Course Instances",                
                fields: {
                    courseCode: 'Course Id',
                    locationDescription: 'Location'
                }
            },
            CreditLevel: {
                name: 'Credit Level |||| Credit Levels',
                fields: {
                    Title: 'Credit Level'
                }
            },
            CourseLevel: {
                name: 'Course Level |||| Course Levels',
                fields: {
                    maxcredits: 'Maximum Credits',
                    description: 'Course Level'
                }
            },
            FacultyGroup: {
                name: 'Schools/Directorate |||| Schools/Directorates',
            },
            FacultySubGroup: {
                name: 'Subject Area |||| Subject Areas'
            },
            Assessment: {
                name: 'Assessment |||| Assessments',
                fields: {
                    title: 'Assessment Code',
                    assessmentType: 'Assessment Type',
                    category: 'Assessment Category'
                }
            },
        }
    }
};
